import { designService } from '@paragon/data-connections';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { analysisHistoryLoaded } from '../slices/analysisHistorySlice';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadHistoriesForComponentDesigns(componentDesignGuids: readonly string[]): AsyncThunkActionVoid {
  return async function loadHistoryForComponentDesignsThunkAction(dispatch) {
    const spinnerId = dispatch(addSpinnerMessage('Loading history for component designs...'));

    try {
      const analysisHistory = await designService.analysisHistory.bulkLoad(componentDesignGuids);
      dispatch(analysisHistoryLoaded(analysisHistory));
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };
}
